import { useQuery } from "@tanstack/react-query";

import {
  formatUtcHourDocId,
  type MetricRangeValue,
} from "@/features/dashboard/shell";

import { MEDDREAM_CRON_INTERVAL_MS } from "../constants";
import {
  getMeddreamHourById,
  queryMeddreamHourlyMetrics,
} from "../services/meddream-metrics";

export const meddreamMetricsKeys = {
  all: ["meddream-hourly-metrics"] as const,
  range: (range: MetricRangeValue) =>
    [...meddreamMetricsKeys.all, "range", range] as const,
  currentHour: (docId: string) =>
    [...meddreamMetricsKeys.all, "current", docId] as const,
};

/**
 * Métricas horarias del rango seleccionado (solo lectura).
 */
export function useMeddreamHourlyMetrics(range: MetricRangeValue) {
  return useQuery({
    queryKey: meddreamMetricsKeys.range(range),
    queryFn: () => queryMeddreamHourlyMetrics(range),
    staleTime: MEDDREAM_CRON_INTERVAL_MS,
    refetchInterval: MEDDREAM_CRON_INTERVAL_MS,
  });
}

/**
 * Documento de la hora UTC en curso (proxy de estado actual).
 */
export function useMeddreamCurrentHour(now: Date = new Date()) {
  const docId = formatUtcHourDocId(now);
  return useQuery({
    queryKey: meddreamMetricsKeys.currentHour(docId),
    queryFn: () => getMeddreamHourById(docId),
    staleTime: MEDDREAM_CRON_INTERVAL_MS / 2,
    refetchInterval: MEDDREAM_CRON_INTERVAL_MS,
  });
}
